/**
 * src/lib/nav/quoteNav.js — race-free "open quote Q" request (mirrors
 * projectNav.js). Lets a deeply-nested component (TaskCard, TaskDetailPanel)
 * open the full-screen quote builder without prop-drilling AppShell's
 * deepLinkQuoteId setter through every task-rendering view.
 */

let pending = null;
const listeners = new Set();

/** Request that AppShell open the quote builder for `quoteId`. */
export function requestQuoteOpen(quoteId) {
  if (!quoteId) return;
  pending = quoteId;
  listeners.forEach((l) => {
    try { l(quoteId); } catch { /* spine-emit-ok: a listener error must not break navigation */ }
  });
}

/** Subscribe to new requests; returns an unsubscribe fn. */
export function subscribeQuoteOpen(cb) { listeners.add(cb); return () => listeners.delete(cb); }

/* Quote-review tasks are tagged `quote_review:<quoteId>` (lib/handlers/quotes/
 * reviewTasks.mjs). One parser for every surface that needs the quote behind a task. */
const REVIEW_TAG = 'quote_review:';
export function quoteIdFromTask(task) {
  const tag = task?.work_tag;
  return (typeof tag === 'string' && tag.startsWith(REVIEW_TAG)) ? tag.slice(REVIEW_TAG.length) || null : null;
}
export const isQuoteReviewTask = (task) => quoteIdFromTask(task) !== null;

/** Test helper. */
export function _resetQuoteNav() { pending = null; listeners.clear(); }
